import {
  BrowserModule,
  provideClientHydration,
  withHttpTransferCacheOptions,
  withEventReplay,
} from '@angular/platform-browser';
import { inject, NgModule, provideAppInitializer, REQUEST, PLATFORM_ID, TransferState, Renderer2, RendererFactory2, REQUEST_CONTEXT } from '@angular/core';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import Aura from '@primeng/themes/aura';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
//import { reducers, metaReducers } from './reducers';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { LayoutMainComponent } from './layout-main/layout-main.component';
import {
  HTTP_TRANSFER_CACHE_ORIGIN_MAP,
  HttpClient,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  AnalyticsService,
  ApiResponse,
  CookieModule,
  DefaultRouteReuseStrategy,
  EnvService,
  HrraRequestContext,
  // EnvServiceProvider,
  LocalDataStorageService,
  LogginService,
  SmartHttpService,
  StaticFeatureFlagService,
  TransferStateOriginMap,
  URL_CONFIG_TOKEN,
  UrlConfigService,
} from '@hrra/core';
import { RootStoreModule } from './root-store';
import { AnnouncementModule } from './announcement/announcement.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularSvgIconModule, SvgLoader } from 'angular-svg-icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { UiModule } from '@hrra/ui';
import {
  TranslateModule,
  TranslateLoader,
  TranslateCompiler,
} from '@ngx-translate/core';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
// import { LayoutHeaderComponent } from './layout-header/layout-header.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CvBoxModule } from './cv-box/cv-box.module';
import { SharedModule } from './shared/shared.module';
import { LayoutFooterComponent } from './layout-footer/layout-footer.component';
import { CustomerModule } from './customer/customer.module';
// import { NgxWebstorageModule } from 'ngx-webstorage';
import { HrUiModule } from './hr-ui/hr-ui.module';
import { MatDialogModule } from '@angular/material/dialog';
import { HeaderModule } from './header/header.module';
// import { TransferHttpCacheModule } from '@angular/ssr';
import { translateBrowserLoaderFactory } from '@hrra/core';
import { SvgBrowserLoader } from './core/svg-browser-loader';
import { InfoPagesModule } from './info-pages/info-pages.module';
import { LoggingModule } from '@hrra/core';
import { newUrlConfig, UrlConfigContainer } from './core/url-config';
import { BannerModule } from './banner/banner.module';
import { JobseekerEmailVerificationComponent } from './jobseeker-email-verification/jobseeker-email-verification.component';
// import { CookieModule } from 'ngx-cookie';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LocationService } from 'libs/common-components/src/lib/shared/services/location.service';
import { SpecializationService } from 'libs/common-components/src/lib/shared/services/specialization.service';
import { IndustryService } from 'libs/common-components/src/lib/shared/services/industry.service';
import { JobseekerLocationService } from './shared/services/jobseeker-location.service';
import { RouteReuseStrategy } from '@angular/router';
import { AdminSigninComponent } from './admin-signin/admin-signin.component';
import { SpecializationPublicService } from './shared/services/specialization-public-service';
import { IndustryPublicService } from './shared/services/industry-public-service';
import { APP_BASE_HREF, DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { APP_VERSION } from '@hrra/core';
import { SsrService } from '@hrra/core';
import { provideNgxWebstorage, withLocalStorage } from 'ngx-webstorage';
import { providePrimeNG } from 'primeng/config';
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';
import { AppConfig, AppTenantConfig } from './core/app-config';
import { LocaleService } from './core/locale.service';
import { usePreset } from '@primeng/themes';
import { primengThemes } from './primeng-themes/primeng-themes';
import { GoogleTagManagerConfiguration, GoogleTagManagerModule } from 'angular-google-tag-manager';
import { ApiTypes } from './core/api-types';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { OpenFeature, NOOP_PROVIDER } from '@openfeature/web-sdk';
import { FlagsmithClientProvider } from '@openfeature/flagsmith-client-provider';
import { OpenFeatureModule } from '@openfeature/angular-sdk';
import { UniqueGuidService } from '@hrra/core';

//declare var window: any;

@NgModule({
  declarations: [
    AppComponent,
    LayoutMainComponent,
    //LayoutHeaderComponent,
    LayoutFooterComponent,
    JobseekerEmailVerificationComponent,
    AdminSigninComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule, //.withServerTransition({ appId: 'serverApp' }),
    // TransferHttpCacheModule,
    // AngularSvgIconModule.forRoot(),
    // NgxWebstorageModule.forRoot(),
    AngularSvgIconModule.forRoot({
      loader: {
        provide: SvgLoader,
        useFactory: svgLoaderFactory,
        deps: [HttpClient, TransferState],
      },
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateBrowserLoaderFactory,
        deps: [HttpClient, TransferState, APP_VERSION, EnvService],
      },
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler,
      },
    }),
    // StoreModule.forRoot(reducers; {
    //   metaReducers
    // }),
    // EffectsModule.forRoot([]),
    AnnouncementModule,
    CvBoxModule,
    //JobseekerModule,
    CustomerModule,
    //SubscriberModule,
    SharedModule,
    InfoPagesModule,
    BannerModule,
    AppRoutingModule,
    HrUiModule,
    UiModule,
    MatSnackBarModule,
    RootStoreModule,
    StoreRouterConnectingModule.forRoot(),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
      connectInZone: true,
    }),
    BrowserAnimationsModule,
    MatDialogModule,
    MatAutocompleteModule,
    HeaderModule,
    LoggingModule.forBrowser(),
    CookieModule.forRoot(),
    InfiniteScrollModule,
    GoogleTagManagerModule.forRoot(),
    OpenFeatureModule.forRoot({
      provider: NOOP_PROVIDER
    })
  ],
  providers: [
    // provideClientHydration(
    //   // withHttpTransferCacheOptions({
    //   //   includeHeaders: ['content-type'],
    //   // })
    // ),

    //EnvServiceProvider,
    // EnvService,
    provideAppInitializer(appInitializer),
    {
      provide: URL_CONFIG_TOKEN,
      useValue: newUrlConfig,
    },
    // {
    //   //TODO: use EnvService
    //   provide: 'googleTagManagerId',
    //   useFactory: (envService: EnvService) => {
    //     console.log('GTM ID:', envService.gtmId);
    //     return envService.gtmId;
    //   },
    //   deps: [EnvService]
    // },
    {
      provide: LocationService,
      useClass: JobseekerLocationService,
    },
    {
      provide: LocalDataStorageService,
      useClass: LocalDataStorageService,
    },
    {
      provide: SpecializationService,
      useClass: SpecializationPublicService,
    },
    {
      provide: IndustryService,
      useClass: IndustryPublicService,
    },
    {
      provide: RouteReuseStrategy,
      useClass: DefaultRouteReuseStrategy,
    },
    {
      provide: APP_BASE_HREF,
      useFactory: (env: EnvService, ssr: SsrService, locale: LocaleService) => {
        // Prefix the base href with the locale so PathLocationStrategy adds it to
        // every routerLink and strips it from incoming URLs. '' for the default
        // language (served at the root), 'en/' for a prefixed language.
        const prefix = locale.getLocalePrefix();

        if (ssr.isPlatformBrowser()) {
          return window.location.origin + env.appBaseHref + prefix;
        }
        return '/' + prefix;
      },
      deps: [EnvService, SsrService, LocaleService],
    },
    {
      provide: APP_VERSION,
      useFactory: (env: EnvService) => {
        return env.appVersion;
      },
      deps: [EnvService],
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic'
      }
    },
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideNgxWebstorage(withLocalStorage()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false || 'none'
        }
      },
    }),
    provideClientHydration(withEventReplay(), withHttpTransferCacheOptions({
      includeHeaders: ['content-type', 'cache-control'],
      includePostRequests: true
    })),
  ],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function svgLoaderFactory(
  http: HttpClient,
  transferState: TransferState
) {
  return new SvgBrowserLoader(transferState, http);
}




export function appInitializer() {
  const httpClient = inject(HttpClient);
  const request = inject(REQUEST);
  const requestContext: HrraRequestContext = <HrraRequestContext> inject(REQUEST_CONTEXT, { optional: true });
  const platformId = inject(PLATFORM_ID);
  const envService = inject(EnvService);
  const urlConfigService = inject(UrlConfigService<UrlConfigContainer>);
  const smartHttpService = inject(SmartHttpService);
  const uniqueGuidService = inject(UniqueGuidService);
  const document = inject(DOCUMENT);
  const rendererFactory = inject(RendererFactory2);
  const renderer2 = rendererFactory.createRenderer(document, null);
  const logService = inject(LogginService);
  const googleTagManagerConfiguration = inject(GoogleTagManagerConfiguration);
  const staticFeatureFlagService = inject(StaticFeatureFlagService);
  const analyticsService = inject(AnalyticsService);



  let originMap = null;

  if( isPlatformServer(platformId) ) {
    originMap = inject(HTTP_TRANSFER_CACHE_ORIGIN_MAP);
  }

  const defaultConfig: Observable<AppTenantConfig> = of({
    tenantId: 0,
    tenantDomainName: 'default',
    config: {
      apiConfig: {
        [ApiTypes.PublicApi]: 'https://api.example.com',
        [ApiTypes.AnalyticsApi]: 'https://analytics.example.com'
      },
      appBaseHref: '/',
      appVersion: '1.0.0',
      logLevel: 'info',
      gtmId: '',
      topGeOn: '',
      topGeId: ''
    }
  } as AppTenantConfig)

  let host: string | null | undefined = null;
  let protocol: string | null = null;
  
  if (isPlatformServer(platformId) && request !== null) {
    //TODO when running server side, read from disk and cache to optimize performance? How to handle transferstate in this case?
    host = request?.headers.get('host');
    protocol = URL.parse(request.url).protocol;
  }
  else if (isPlatformBrowser(platformId)) {
    host = window.location.host;
    protocol = window.location.protocol;
  }

  if (host === null) {
    logService.logger.warn('Host is null, returning default config');
    return defaultConfig;
  }
  else {

    const baseUrl = `${protocol}//${host}`;

    let configBaseUrl = baseUrl;

    if(isPlatformServer(platformId) && requestContext !== null){
      const configHost = 'localhost';
      const port = requestContext.port;
      const protocol = requestContext.internalProtocol;


      configBaseUrl = `${protocol}://${configHost}:${port}`;
    }

    return httpClient.get<AppConfig>(`${configBaseUrl}/assets/conf/api.json`)
      .pipe(map(config => {

        const hostName = host.split(':')[0];

        const result = config.tenants.filter(tenant => hostName.includes(tenant.tenantDomainName));
        if(result.length == 0){
          logService.logger.error('Tenant config not found for host: %s', hostName);
        }
        else if(result.length > 1) {
          logService.logger.error({ hostName, configs: result }, 'Multiple tenant configs found for host: %', hostName);
        }
        else {
          return  { logging: config.logging, cacheConfig: config.cacheConfig, wafConfig: config.wafConfig, httpClientConfig: config.httpClientConfig, featureFlagConfig: config.featureFlagConfig, staticFeatureFlags: config.staticFeatureFlags, tenantConfig: result[0], analyticsConfig: config.analyticsConfig };
        }
      }),
        tap(({logging, tenantConfig, cacheConfig, wafConfig, httpClientConfig, featureFlagConfig, staticFeatureFlags, analyticsConfig}) => {
          const publicApiConfig = tenantConfig.config.apiConfig;
          const internalApiConfig = tenantConfig.config.internalApiConfig;
          const theme = tenantConfig.config.theme;

          //theming
          document.documentElement.classList.add(`${theme}`);
          //material theming
          const style = renderer2.createElement('link') as HTMLLinkElement;
          renderer2.appendChild(document.head, style);
          style.rel = 'stylesheet';
          renderer2.setAttribute(style, 'rel', 'stylesheet');
          renderer2.setAttribute(style, 'type', 'text/css');
          renderer2.setAttribute(style, 'href', `mat-${theme}.css`);

          //

          const favicon = renderer2.createElement('link') as HTMLLinkElement;
          renderer2.appendChild(document.head, favicon);
          favicon.rel = 'icon';
          renderer2.setAttribute(favicon, 'rel', 'icon');
          renderer2.setAttribute(favicon, 'type', 'image/x-icon');
          renderer2.setAttribute(favicon, 'href', `favicon-${theme}.ico?v=${tenantConfig.config.appVersion}`);

          let anonymousId = null;
          //genrate target key based on number if buckets (if no a/b experiements are currently running set bucjet number to 1, other wsie 10, 100..; (%bucket_number) from hash of anonnymousId is the targeting key)

          if (isPlatformBrowser(platformId)) {
            //important generate anounymous id only in client side, when running in browser
            anonymousId = uniqueGuidService.getOrCreateUniqueGuid();
          }
          

          if(featureFlagConfig.enabled){
            const featureApiUrl = isPlatformServer(platformId) ? featureFlagConfig.serverApiBaseUrl : featureFlagConfig.apiBaseUrl;
            
            OpenFeature.setProvider(new FlagsmithClientProvider({
              environmentID: featureFlagConfig.apiKey,
              api: featureApiUrl,
              cacheFlags: featureFlagConfig.enableCaching,
              cacheOptions: {
                ttl: featureFlagConfig.ttl,
                skipAPI: false
              }

            }));

            // OpenFeature.setContext({
            //   targetingKey: "" //or null
            // });
          }


          if(isPlatformBrowser(platformId)){
            envService.apiConfig = tenantConfig.config.apiConfig;
          }
          else if (isPlatformServer(platformId)) {
            // For server-side rendering, we can use the internal API config
            envService.apiConfig = tenantConfig.config.internalApiConfig;

            const mappings: { internalApi: string, publicApi: string }[] = [];
            
            for(const key of Object.keys(internalApiConfig)) {
              if(Object.prototype.hasOwnProperty.call(internalApiConfig, key)){
                if(Object.prototype.hasOwnProperty.call(publicApiConfig, key)){
                  mappings.push({
                    internalApi: URL.parse(internalApiConfig[key]).origin,
                    publicApi: URL.parse(publicApiConfig[key]).origin
                  });
                }
              }
            }

            TransferStateOriginMap.init(originMap, mappings);
          }
          else {
            logService.logger.error('Unknown platform, cannot set API config');
          }

          googleTagManagerConfiguration.set({
            id: tenantConfig.config.gtmId
          });

          envService.theme = tenantConfig.config.theme;
          envService.logConfig = logging;
          envService.cacheConfig = cacheConfig;
          envService.wafConfig = wafConfig;
          envService.tenantId = tenantConfig.tenantId;
          envService.appBaseHref = tenantConfig.config.appBaseHref;
          envService.localeConfig = tenantConfig.config.localeConfig;
          envService.appVersion = tenantConfig.config.appVersion;
          envService.logLevel = tenantConfig.config.logLevel || logging.level;
          envService.analyticsConfig = analyticsConfig;
          logService.applyLogConfig(logging);
          smartHttpService.loadConfig(httpClientConfig);
          staticFeatureFlagService.init(staticFeatureFlags);
          urlConfigService.init();
          analyticsService.init();

        }),
        catchError(err => {
          logService.logger.error('Error loading config', err);
          return throwError(() => err);
        })
      );
  }

}
